// Goodbye.jsx
// Shows a friendly goodbye message after logout and redirects to signin page

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '../../utils/logger';
import './Goodbye.css';

const Goodbye = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logger.log('📂 [Goodbye] Component mounted - showing goodbye message');
    
    // Redirect to signin after 3 seconds
    const timer = setTimeout(() => {
      logger.log('📂 [Goodbye] Redirecting to signin page');
      navigate('/signin', { replace: true });
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div className="goodbye-container">
      <div className="goodbye-content">
        <div className="goodbye-icon">👋</div>
        <h1 className="goodbye-title">Bye Bye!</h1>
        <p className="goodbye-message">Come back soon!</p>
        <p className="goodbye-submessage">You've been successfully signed out.</p>
        <div className="goodbye-spinner">
          <div className="spinner"></div>
        </div>
        <p className="goodbye-redirect">Redirecting to sign in...</p>
      </div>
    </div>
  );
};

export default Goodbye;












